import React from "react";

export default function Box({ _id, onDelete, onEdit, onVisibilityChange, onQR, ...props }) {
  const dataToEdit = { ...props };
  delete dataToEdit.path;
  delete dataToEdit.createdAt;
  delete dataToEdit.updatedAt;
  delete dataToEdit.__v;

  const handleQR = () => {
    const comp = /intermediate/i.test(props["Certificate/Program"]) ? "Inter" : /matric/i.test(props["Certificate/Program"]) ? "Matric" : "";
    
    document.dispatchEvent(
      new CustomEvent("showQR", {
        detail: {
          path: props.path,
          refCode: props["Reference No"].split("-")[1],
          degree: `${props["Certificate/Program"].split("/")[0].trim()}${comp && "/" + comp}`,
        },
      })
    );
    onQR("ibcc");
  };
  return (
    <div className="box-data-main">
      <button onClick={() => onEdit({ ...dataToEdit, _id })}>Edit</button>
      <button onClick={() => onDelete(_id)}>Delete</button>
      <button onClick={() => onVisibilityChange(_id, dataToEdit.status == "hidden" ? "show" : "hidden")}>{dataToEdit.status == "hidden" ? "Show" : "Hide"}</button>
      <button onClick={() => window.open(process.env.REACT_APP_QR_PREFIX + props.path, "_blank")}>View</button>
      <button onClick={handleQR}>QR</button>
      <p>
        <strong>Board:</strong> {props.Board}
      </p>
      <p>
        <strong>Certificate/Program:</strong> {props["Certificate/Program"]}
      </p>
      <p>
        <strong>Father Name:</strong> {props["Father Name"]}
      </p>
      <p>
        <strong>Group:</strong> {props.Group}
      </p>
      <p>
        <strong>Marks:</strong> {props.Marks}
      </p>
      <p>
        <strong>Passing Year - Session:</strong> {props["Passing Year - Session"]}
      </p>
      <p>
        <strong>Reference No:</strong> {props["Reference No"]}
      </p>
      <p>
        <strong>Roll No:</strong> {props["Roll No"]}
      </p>
    </div>
  );
}
